import $ from 'jquery'

$(document).on('turbo:load', () => {
  // Set datepicker according to selected time_period
  // ---------------------------------------------------------------------

  const selectTimePeriod = $('.output #search_time_period')

  const datepickerDaily = $('.output .datepickers .datepicker_daily')
  const datepickerMonthly = $('.output .datepickers .datepicker_monthly')
  const datepickerYearly = $('.output .datepickers .datepicker_yearly')

  selectTimePeriod.on('change', () => {
    const timePeriod = selectTimePeriod.find(':selected').val()
    switch (timePeriod) {
      case 'daily':
        datepickerDaily.show().find('*').attr('disabled', false)
        datepickerMonthly.hide().find('*').attr('disabled', true)
        datepickerYearly.hide().find('*').attr('disabled', true)
        break
      case 'monthly':
        datepickerMonthly.show().find('*').attr('disabled', false)
        datepickerDaily.hide().find('*').attr('disabled', true)
        datepickerYearly.hide().find('*').attr('disabled', true)
        break
      case 'yearly':
        datepickerYearly.show().find('*').attr('disabled', false)
        datepickerDaily.hide().find('*').attr('disabled', true)
        datepickerMonthly.hide().find('*').attr('disabled', true)
        break
    }
  })

  // Also trigger everything after page (re)load, e.g. validation fail
  selectTimePeriod.trigger('change')
})
